<template>
  <div>
    <div class="chapter-head" v-if="item.p_id==0">
      <img src="@img/chapter.png" alt />
      <span>{{item.name}}</span>
    </div>
    <div class="chapter-section" v-if="item.p_id && item.p_id !=0">
      <img src="@img/section.png" alt />
      <span>{{item.name}}</span>
    </div>
    <div class="chapter-matter" v-if="item.video_name">
      <div class="chapter-item">
        <div class="chapter-left">
          <img src="@img/video.png" alt />
          <span>{{item.video_name}}</span>
        </div>
        <div class="btn color1" v-if="item.living == 0">未开播</div>
        <div class="btn color2" @click="showVideo(item)" v-if="item.living == 1">直播中</div>
        <div class="btn color1" v-if="item.living == 2">休息中</div>
        <div class="btn color1" v-if="item.living == 3">已结束</div>
        <div class="btn color3" @click="showVideo(item)" v-if="item.living == 4">直播回放</div>
        <div class="btn color2" @click="showVideo(item)" v-if="!item.living">立即观看</div>
      </div>
    </div>
    <div v-if="item.children">
      <courses v-for="ix in item.children" :key="ix.id" :item="ix"></courses>
    </div>
    <a-alert
      class="toast"
      message="播放错误"
      description="请先购买视频"
      type="error"
      showIcon
      v-if="showToast"
    />
    <a-alert :message="errmsg" v-if="errshow" class="errshow" type="error" showIcon />
  </div>
</template>
<script>
import {
  apiCheckVideoAuth,
  apiCheckLiveUrlToken,
  apiCheckPlaybackUrlToken
} from "@/api/course";
import { setTimeout, clearTimeout } from "timers";
export default {
  name: "courses",
  props: ["item", "course"],
  data() {
    return {
      showToast: false,
      errshow: false,
      errmsg: ""
    };
  },
  created() {
    // console.log(course)
  },
  methods: {
    showVideo(item, course) {
      let that = this;
      let course_id = this.$route.query.course_id;
      let course_type = this.$route.query.course_type;
      if (course_type == 0) {
        let course = this.$store.state.course;
        console.log("=========>",course);
        return new Promise((resolve, reject) => {
          if (course.pay_status == 1 || course.is_free == 1) {
            apiCheckVideoAuth({ course_id: course_id, video_id: item.id })
              .then(res => {
                if (typeof res.result.returncode == "undefined" || res.result.returncode == 0) {
                  that.$store.commit("setState", {
                    key: "video_url",
                    value: res.result[0].video_url
                  });
                  that.$store.commit("setState", {
                    key: "video_name",
                    value: item.video_name
                  });
                  that.$store.commit("setState", {
                    key: "showVideo",
                    value: true
                  });
                } else {
                  
                  that.errmsg = res.result.returnmsg;
                  that.errshow = true;
                  let timeErrzz = setTimeout(() => {
                    that.errshow = false;
                    that.errmsg = "";
                    clearTimeout(timeErrzz);
                  }, 2000);
                }
              })
              .catch(error => {
                console.log(error, "视频错误");
              });
          } else {
            that.showToast = true;
            let timer = setTimeout(function() {
              that.showToast = false;
              clearTimeout(timer);
            }, 2000);
          }
        });
      } else if (course_type == 1) {
        switch (item.living) {
          case 1:
            return new Promise((resolve, reject) => {
              apiCheckLiveUrlToken({ course_id: that.$route.query.course_id })
                .then(res => {
                  if (res.errcode == 0) {
                    let url = res.result.rtmp_show_url;
                    that.$router.push({
                      path: "/page/live_room",
                      query: {
                        id: that.$route.query.course_id,
                        source: url,
                        course_type: that.$route.query.course_type,
                        name: item.video_name
                      }
                    });
                  } else {
                    that.errmsg = res.errmsg;
                    that.errshow = true;
                    let timeErrww = setTimeout(() => {
                      that.errshow = false;
                      that.errmsg = "";
                      clearTimeout(timeErrww);
                    }, 2000);
                  }
                })
                .catch(error => {});
            });
            break;
          case 4:
            return new Promise((resolve, reject) => {
              apiCheckPlaybackUrlToken({
                course_id: course_id,
                video_id: item.id
              })
                .then(res => {
                  that.$store.commit("setState", {
                    key: "video_url",
                    value: res.result.video_url
                  });
                  that.$store.commit("setState", {
                    key: "video_name",
                    value: item.video_name
                  });
                  that.$store.commit("setState", {
                    key: "showVideo",
                    value: true
                  });
                })
                .catch(error => {
                  console.log(error, "视频错误");
                });
            });
            break;
          default:
            break;
        }
      }
    }
  }
};
</script>
<style lang="less" scoped>
.chapter-head {
  display: flex;
  align-items: center;
  height: 50px;
  img {
    margin-right: 15px;
    width: 20px;
    height: 20px;
  }
}
.chapter-section {
  display: flex;
  align-items: center;
  height: 50px;
  img {
    margin-right: 15px;
    width: 20px;
    height: 20px;
  }
}
.chapter-matter {
  display: flex;
  align-items: center;
  height: 50px;
  .chapter-item {
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    .chapter-left {
      display: flex;
      align-items: center;
      img {
        width: 20px;
        height: 20px;
        margin-right: 15px;
      }
    }
    .btn {
      width: 62px;
      cursor: pointer;
      height: 24px;
      text-align: center;
      color: #fff;
      line-height: 24px;
      font-size: 12px;
      border: 1px solid transparent;
      border-radius: 4px;
    }
    .color2 {
      background: #93cf51;
    }
    .color1 {
      background: #e6e6e6;
    }
    .color3 {
      background: #3b9dff;
    }
  }
}
.toast {
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 400px;
}
.errshow {
  position: fixed;
  width: 50%;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: 8888;
}
</style>
